import type { SfxName } from "../sound/sfx";

/*
 * WHEN هفت خبیث SOUNDS: AT THE ANIMATION'S REAL MOMENT, AND A CLIP'S OWN LEAD-IN COUNTS. `card-play.mp3` opens with
 * 262 ms before its snap and `card-deal.mp3` with 296 ms, so a `playSfx` at the landing is heard a third of a second
 * after the card has stopped. Every cue is therefore asked for this long BEFORE its moment. The figures are read off
 * the app's own decoder (`tools/haftkhabis-layout-probes/sfx-leads.cjs`: where the clip's envelope first passes −6 dB
 * under its own peak, its attack; the shuffle's slow build by −20 dB, where it is first heard); `SOUND.md` beside it
 * has the table of every event → clip → moment.
 */

/** Per clip this table plays: ms from `playSfx` to the clip's attack. */
export const CLIP_LEAD_MS = {
  play: 262, // card-play.mp3: the snap
  deal: 296, // card-deal.mp3: the card down
  pass: 296, // card-deal.mp3
  shuffle: 58, // shuffle.mp3: its riffle begins (its loudest is 0.6 s in)
  qspade: 51, // qspade.mp3
  surCancel: 51, // qspade.mp3
  sur: 58, // hearts-broken.mp3
  heartsBroken: 58, // hearts-broken.mp3
  trickWin: 47, // trick-win.mp3
  trickLose: 155, // trick-lose.mp3
  bid: 49, // bg-checker-place.mp3
  trumpCall: 21, // trump-call.wav
} as const satisfies Partial<Record<SfxName, number>>;

export type HaftkhabisClip = keyof typeof CLIP_LEAD_MS;

/** Every clip this table can play: warmed when it mounts, so the first of each is on time too. */
export const HAFTKHABIS_CLIPS = Object.keys(CLIP_LEAD_MS) as readonly HaftkhabisClip[];

/** When to ask for `clip` so it is heard at `moment` (never before the timeline starts). */
export const cueAt = (moment: number, clip: HaftkhabisClip): number =>
  Math.max(0, moment - CLIP_LEAD_MS[clip]);
